module.exports = __webpack_public_path__ + "static/media/clockIcon.2b2fb22e.png";